import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import TitleManager from "./components/TitleManager";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import KnowledgeTest from "./pages/KnowledgeTest";
import FakeChecklist from "./pages/FakeChecklist";
import Leaderboards from "./pages/Leaderboards";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Wiki from "./pages/Wiki";
import WikiArticle from "./pages/WikiArticle";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <TitleManager />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/test/knowledge" element={<KnowledgeTest />} />
                <Route path="/checklist/fake-nlp" element={<FakeChecklist />} />
                <Route path="/leaderboards" element={<Leaderboards />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/wiki" element={<ProtectedRoute><Wiki /></ProtectedRoute>} />
                <Route path="/wiki/:slug" element={<ProtectedRoute><WikiArticle /></ProtectedRoute>} />
                <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
                <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              </Routes>
            </Layout>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
